<template>
  <input
    type="text"
    :placeholder="placeholder"
    :disabled="disabled"
    :value="value"
    ref="inputComma"
    @input="handleInput"
    @blur="handleBlur"
    inputmode="numeric"
    class="input01"
  />
</template>

<script>
import mixin from '@/utils/mixin';

export default {
  mixins: [mixin],
  model: {
    prop: 'value',
    event: 'custom-input',
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeSelection(value, selection) {
      if (!value) return '';
      const frontNo = this.removeComma(value.substring(0, selection)).toString().length,
        allComma = parseInt((this.removeComma(value).toString().length - 1) / 3),
        endComma = this.addComma(value.substring(selection)).split(',').length - 1,
        endLenght = (this.addComma(value.substring(selection)).toString().length - 3) % 4;
      if (endLenght === 0 && selection !== 0) {
        return frontNo + allComma - endComma - 1;
      } else {
        return frontNo + allComma - endComma;
      }
    },
    handleInput() {
      const el = this.$refs.inputComma;
      el.oldValue = this.addComma(el.value);
      el.oldSelectionStart = this.changeSelection(el.value, el.selectionStart);
      el.oldSelectionEnd = this.changeSelection(el.value, el.selectionEnd);
      this.$nextTick(() => {
        el.value = el.oldValue;
        el.setSelectionRange(el.oldSelectionStart, el.oldSelectionEnd);
      });

      this.$emit('custom-input', el.oldValue);
    },
    handleBlur() {
      const el = this.$refs.inputComma;
      el.oldValue = this.removeComma(el.value).replace(/(^0+)/, '');
      this.$nextTick(() => {
        el.value = this.addComma(el.oldValue);
      });

      this.$emit('custom-blur', el.oldValue);
    },
  },
};
</script>
